import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { ConfirmationComponent } from '../shared/confirmation/confirmation.component';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {
  }

  snackbar(message: string, action = '關閉', config: MatSnackBarConfig = {}): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, { ...config });
  }

  confirm(message: string, title = '提示'): MatDialogRef<ConfirmationComponent, boolean> {
    return this.dialog.open(ConfirmationComponent, {
      data: {
        title,
        message
      }
    });
  }
}
